import { api } from '@/services'
import {
  fetchQuestionnaires,
  fetchQuestionnaire,
  createQuestionnaire,
  publish,
  updateQuestionnaire,
} from '@/services/questionnaire/questionnaireService'

const state = {
  appointmentQuestionnaires: {},
  questionnaires: [],
  questionnaire: {},
  isQuestionnaireLoading: false
}

const getters = {
  appointmentQuestionnaires: (state) => state.appointmentQuestionnaires,
  questionnaires: (state) => state.questionnaires,
  questionnaire: (state) => state.questionnaire,
  isQuestionnaireLoading: (state) => state.isQuestionnaireLoading,
}

const actions = {
  async fetchAppointmentQuestionnaires({ commit, dispatch }, id) {
    commit('setAppointmentQuestionnaires', {})
    commit('setIsQuestionnaireLoading', true)

    let params = {
      appointmentId: id
    }

    try {
      const { data } = await api.get('/web/questionnaire/', { params: params })

      commit('setAppointmentQuestionnaires', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsQuestionnaireLoading', false)
    }
  },

  async fetchQuestionnaires({ commit, dispatch, rootState }) {
    commit('setIsQuestionnaireLoading', true)

    const defaultParams = {
      activesOnly: false,
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = {
      ...defaultParams,
      ...rootState.filters.filters
    }

    try {
      const { data } = await fetchQuestionnaires(params)
      const { result, total } = await data
      commit('setQuestionnaires', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsQuestionnaireLoading', false)
    }
  },

  async fetchQuestionnaire({ commit, dispatch }, id) {
    commit('setQuestionnaire', {})
    commit('setIsLoading', true)

    try {
      const { data } = await fetchQuestionnaire(id)
      commit('setQuestionnaire', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async saveQuestionnaire(_, questionnaire) {
    return await createQuestionnaire(questionnaire)
  },

  async updateQuestionnaire(_, questionnaire) {
    return await updateQuestionnaire(questionnaire)
  },

  async publishQuestionnaire(_, id) {
    return await publish(id)
  },
}

const mutations = {
  setAppointmentQuestionnaires: (state, appointmentQuestionnaires) => {
    state.appointmentQuestionnaires = appointmentQuestionnaires
  },

  setQuestionnaires: (state, questionnaires) => {
    state.questionnaires = questionnaires
  },

  setQuestionnaire: (state, questionnaire) => {
    state.questionnaire = questionnaire
  },

  setIsQuestionnaireLoading: (state, status) => {
    state.isQuestionnaireLoading = status
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}
